// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\CustomerSearchResponse

import { hydrateCustomerWithBookings, type CustomerWithBookings, type CustomerWithBookingsApiResponse } from './customerWithBookings.gen';

export type CustomerSearchApiResponse = {
	items: CustomerWithBookingsApiResponse[];
};

export type CustomerSearch = {
	items: CustomerWithBookings[];
};

export function hydrateCustomerSearch(data: CustomerSearchApiResponse): CustomerSearch {
	return {
		...data,
		items: data.items.map(hydrateCustomerWithBookings),
	};
}